function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M63.852,193.022c-12.459,2.195-20.772,14.054-18.581,26.513c1.948,11.108,11.604,18.927,22.514,18.927 c1.319,0,2.649-0.116,3.99-0.353l13.202-2.316v47.496c0,12.632,10.253,22.891,22.891,22.891c12.644,0,22.893-10.259,22.893-22.891 v-55.543l40.837-7.185v48.421c0,12.644,10.26,22.891,22.895,22.891c12.64,0,22.891-10.247,22.891-22.891v-56.456l27.996-4.938 c12.451-2.176,20.771-14.042,18.586-26.493c-2.188-12.467-14.062-20.771-26.513-18.582l-20.077,3.526v-47.532l24.954-4.386 c12.451-2.192,20.767-14.06,18.574-26.511c-2.176-12.453-14.065-20.748-26.509-18.582l-17.02,2.989V22.891 C217.374,10.249,207.123,0,194.483,0c-12.635,0-22.895,10.249-22.895,22.891v57.174l-40.837,7.175V37.193 c0-12.638-10.249-22.893-22.892-22.893c-12.638,0-22.891,10.255-22.891,22.893v58.1L60.8,99.541 c-12.461,2.192-20.772,14.06-18.583,26.509c1.946,11.108,11.602,18.937,22.516,18.937c1.318,0,2.645-0.122,3.985-0.353l16.25-2.855 v47.536L63.852,193.022z M130.751,133.74l40.837-7.175v47.522l-40.837,7.178V133.74z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var SvgHits = function SvgHits(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    width: "306.18px",
    height: "306.18px",
    viewBox: "0 0 306.18 306.18",
    style: {
      enableBackground: "new 0 0 306.18 306.18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHits, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Hits.73fb334b.svg";
export { ForwardRef as ReactComponent };